import { stringIsEmpty } from 'utils/stringUtils';
import { RewardFormValues, RewardFormViolation } from 'types/rewardFormTypes';

export const validateRewardFormValues = (
  values: RewardFormValues
): RewardFormViolation[] => {
  const violations: RewardFormViolation[] = [];

  if (stringIsEmpty(values.amount) || Number(values.amount) <= 0) {
    violations.push({
      name: 'AmountMissed',
    });
  }

  if (stringIsEmpty(values.comment)) {
    violations.push({
      name: 'CommentMissed',
    });
  }

  return violations;
};

export function isRewardFormViolation(violation: RewardFormViolation) {
  return {
    isAmountViolation() {
      switch (violation.name) {
        case 'AmountMissed':
        case 'AmountExceedsBalance':
          return true;
        default:
          return false;
      }
    },
    isCommentViolation() {
      switch (violation.name) {
        case 'CommentMissed':
          return true;
        default:
          return false;
      }
    },
  };
}
